import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface NationalIdScreenProps {
  nationalId: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function NationalIdScreen({
  nationalId,
  onChange,
  onNext,
  onBack
}: NationalIdScreenProps) {
  const isValid = nationalId.trim().length >= 12; // MyKad is 12 digits
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-206">
      <div className="flex-1" data-id="element-207">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-208">
          MyKad / NRIC Number
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-209">
          Please enter your Malaysian Identity Card (MyKad) or NRIC number for
          identity verification.
        </p>

        <div className="space-y-6" data-id="element-210">
          <Input label="MyKad / NRIC Number" placeholder="Enter 12-digit IC number" value={nationalId} onChange={e => onChange('nationalId', e.target.value)} autoFocus maxLength={12} data-id="element-211" />
          <div className="bg-blue-50 p-4 rounded-lg border border-blue-100" data-id="element-212">
            <p className="text-sm text-blue-700" data-id="element-213">
              Your information is encrypted and securely stored. We only use
              this for regulatory compliance checks.
            </p>
          </div>
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-214">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-215">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-216">
          Continue
        </Button>
      </div>
    </div>;
}